import script from "./CommentTemplate.vue?vue&type=script&setup=true&lang=ts"
export * from "./CommentTemplate.vue?vue&type=script&setup=true&lang=ts"

import "./CommentTemplate.vue?vue&type=style&index=0&id=1021e740&lang=scss&scoped=true"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1021e740"]])

export default __exports__